export default (api) => {
    return {
        index: options => api.get('challenge_versions', options),
        get: (challenge_id, options) => api.get(`challenge_versions/${challenge_id}`, options),
        student: {
            index: options => api.get('student/challenge_versions', options),
        },
        getGuide: (challenge_code, options) => api.get(`challenge_versions/${challenge_code}/guide`, options)
    }
}
